/* @generated */

// src/assets/ui-icon/line/shuffle.tsx
import * as React from "react";
var ShuffleLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12.73 15.568c.31-.474.581-.972.808-1.49.925 1.559 2.188 2.362 3.243 2.362h.442l-1.029-1.07 1.081-1.04 2.75 2.86-2.75 2.86-1.081-1.04 1.029-1.07h-.457c-1.5-.006-2.944-.902-4.035-2.373ZM17.275 4l-1.081 1.04 1.029 1.07h-.442c-2.452 0-4.763 2.372-5.61 5.737-.98 3.28-3.286 4.828-6.87 4.604a5.112 5.112 0 0 0-.276-.013v1.5c.03 0 .07.003.122.006l.06.004c.267.017.526.025.778.025 4.87 0 6.835-3.058 7.631-5.728.767-3.043 2.677-4.635 4.165-4.635h.442l-1.029 1.07 1.081 1.04 2.75-2.86L17.275 4ZM4.301 7.599a5.275 5.275 0 0 1-.276.012v-1.5c.04 0 .101-.004.182-.01 3.34-.209 5.429.93 6.738 2.483a11.01 11.01 0 0 0-.724 1.53C8.996 8.28 7.012 7.428 4.3 7.6Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ShuffleLine
};
